export interface UpdateLendAndReturnConditionRequest {
  branchCode: string
  lendType: string
  userType: string
  lendDays: {
    id: number
    handlingType: string
    classification: string
    handlingTypeCheck: string
    lendingDays: number | string
    extensionDays: number | string
    extensionLimit: number | string
    revision: number
  }[]
  userLimits: {
    id: number
    numberOfTotalBooks: number | string
    numberOfLatestBooks: number | string
    revision: number
  }
  lendClassifications: {
    numberOfBooks: number | string
    classifications: string[]
    revision: number
  }[]
}

export function UpdateLendAndReturnConditionRequestToJSON(
  value: UpdateLendAndReturnConditionRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    lend_type: value.lendType !== '' ? value.lendType : undefined,
    user_type: value.userType !== '' ? value.userType : undefined,
    lend_days:
      value.lendDays.length > 0
        ? value.lendDays.map(value => {
            return {
              id: value.id, // 0を投げる場合があるのでこの条件式で対応
              handling_type:
                value.handlingType !== '' ? value.handlingType : undefined,
              classification:
                value.classification !== '' ? value.classification : undefined,
              handling_type_check:
                value.handlingTypeCheck !== ''
                  ? value.handlingTypeCheck
                  : undefined,
              lending_days: value.lendingDays,
              extension_days: value.extensionDays,
              extension_limit: value.extensionLimit,
              revision: value.revision // 0を投げる場合があるのでこの条件式で対応
            }
          })
        : undefined,
    user_limits: {
      id: value.userLimits.id ? value.userLimits.id : undefined,
      number_of_total_books: value.userLimits.numberOfTotalBooks,
      number_of_latest_books: value.userLimits.numberOfLatestBooks,
      revision: value.userLimits.revision
        ? value.userLimits.revision
        : undefined
    },
    lend_classifications:
      value.lendClassifications.length > 0
        ? value.lendClassifications.map(value => {
            return {
              number_of_books: value.numberOfBooks,
              classifications:
                value.classifications.length > 0
                  ? value.classifications
                  : undefined,
              revision: value.revision ? value.revision : undefined
            }
          })
        : undefined
  }
}
